import { Show, createSignal } from 'solid-js';
import { PixelIcon } from '../PixelIcon';

interface ShutdownWindowProps {
  cancel: () => void;
}

export function ShutdownWindow(props: ShutdownWindowProps) {
  const [safe, setSafe] = createSignal(false);

  return (
    <div class="window-body shutdown-window">
      <Show
        when={safe()}
        fallback={
          <>
            <div class="shutdown-question">
              <PixelIcon name="shutdown" size={48} />
              <div>
                <p>What do you want the workstation to do?</p>
                <label><input type="radio" name="shutdown-mode" checked /> Shut down the workstation</label>
                <label><input type="radio" name="shutdown-mode" /> Restart the workstation</label>
              </div>
            </div>
            <div class="dialog-buttons">
              <button class="default" onClick={() => setSafe(true)}>Yes</button>
              <button onClick={() => window.location.reload()}>Restart</button>
              <button onClick={props.cancel}>Cancel</button>
            </div>
          </>
        }
      >
        <div class="safe-to-close">
          <div class="safe-logo">IS</div>
          <p>It is now safe to close this browser tab.</p>
          <button onClick={() => window.location.reload()}>Restart</button>
        </div>
      </Show>
    </div>
  );
}
